<form class="grid no-padding" (ngSubmit)="INDRA_findBooking()" [formGroup]="form" [attr.aria-label]="'bookingSearch.aria.findExistingBookingForm' | ibeadmin | async">
	<div class="large-input-group col-12">
		<app-large-input class="pnr-input-wrapper" 
			[minlength]="6" 
			[maxlength]="13" 
			[required]="true" 
			formControlName="pnr" 
			[id]="'pnr'" 
			icon="icons.svg#tickets_related--ticket"
			[label]="'bookingSearch.label.reservationOrTicket' | ibeadmin | async"
			[hasError]="INDRA_PNRhasError()">
		</app-large-input>
		<app-large-input 
			formControlName="last_name" 
			[id]="'last_name'" 
			[required]="true" 
			icon="icons.svg#general--user_2" 
			[label]="'bookingSearch.label.lastName' | ibeadmin | async" 
			[hasError]="INDRA_LastNamehasError()">
		</app-large-input>
	</div>
	<div class="large-input-group-errors col-12" *ngIf="INDRA_showErros()">
			<span class="large-input-group-error" role="alert" aria-live="polite" *ngIf="form.controls['pnr'].hasError('required')">{{ 'bookingSearch.errorMessage.ticketNumberRequired' | ibeadmin | async }}</span>
			<span class="large-input-group-error" role="alert" aria-live="polite" *ngIf="form.controls['last_name'].hasError('required')">{{ 'bookingSearch.errorMessage.lastNameRequired' | ibeadmin | async }}</span>
			<span class="large-input-group-error" role="alert" aria-live="polite" *ngIf="form.controls['pnr'].hasError('minlength')">{{ 'bookingSearch.errorMessage.atleastSixChars' | ibeadmin | async }}</span>
			<span class="large-input-group-error" role="alert" aria-live="polite" *ngIf="form.controls['pnr'].hasError('maxlength')">{{ 'bookingSearch.errorMessage.maxChars' | ibeadmin | async }}</span>
			<span class="large-input-group-error" role="alert" aria-live="polite" *ngIf="form.controls['pnr'].hasError('pattern')">{{ 'bookingSearch.errorMessage.incorrectFormat' | ibeadmin | async }}</span>
			<span class="large-input-group-error" role="alert" aria-live="polite" *ngIf="form.controls['last_name'].hasError('pattern')">{{ 'bookingSearch.errorMessage.invalidLastName' | ibeadmin | async }}</span>
	</div>
	<button class="button col-12" [attr.aria-label]="'bookingSearch.button.findBookingWithPNRLastName' | ibeadmin | async">{{ 'bookingSearch.button.findBooking' | ibeadmin | async }}</button>
</form>
